import { appApiSlice } from "src/api/app-ApiSlice";
import { TAG_USER_CUSTOM_ITEMS } from "src/api/api-tags";
import { GetMyProductResponse, GetMyProductsResponse } from "src/model/api/v2/data-contracts";

export const userCustomItemsV2ApiSlice = appApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getMyProducts: builder.query<GetMyProductsResponse, void>({
            query: () => ({
                url: 'v2/user/get-my-products',
                method: 'GET',
            }),
            providesTags: [TAG_USER_CUSTOM_ITEMS],
        }),
        getMyProduct: builder.query<GetMyProductResponse, { productId: number }>({
            query: ({ productId }) => ({
                url: `v2/user/get-my-product?productId=${productId}`,
                method: "GET",
            }),
            providesTags: [TAG_USER_CUSTOM_ITEMS],
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetMyProductsQuery,
    useGetMyProductQuery,
} = userCustomItemsV2ApiSlice;
